/**
 * Tabular skeleton rows for data grids.
 * Usage:
 *   <GridSkeletonRows cols={10} rows={6} />
 * Must be wrapped inside a <tbody>.
 */
import React from "react";

export function GridSkeletonRows({ cols = 8, rows = 6 }) {
  const items = Array.from({ length: rows });
  return (
    <>
      {items.map((_, r) => (
        <tr
          key={`sk-${r}`}
          style={{ borderTop: "1px solid var(--border-subtle)" }}
          data-testid={`skeleton-row-${r}`}
        >
          {Array.from({ length: cols }).map((__, c) => (
            <td key={c} className="px-3 py-2.5">
              <span
                className="inline-block h-3 rounded"
                style={{
                  width: c === 0 ? "70%" : c % 3 === 0 ? "60%" : "80%",
                  background:
                    "linear-gradient(90deg, var(--bg-subtle) 0%, rgba(0,0,0,0.04) 50%, var(--bg-subtle) 100%)",
                  backgroundSize: "200% 100%",
                  animation: "tq-skel 1.2s ease-in-out infinite",
                }}
              />
            </td>
          ))}
        </tr>
      ))}
      <style>{`@keyframes tq-skel{0%{background-position:200% 0}100%{background-position:-200% 0}}`}</style>
    </>
  );
}
